export default __webpack_public_path__ + "static/media/NunitoSans-Black.a2cd9dc8.ttf";